/**
 * The error texts the Tixologi backend answers with when it rejects a bearer token,
 * copied verbatim from tixologist `src/utils/constants.ts` (snapshot 2f0c9253).
 *
 * INVALID_TOKEN is the tail of the Firebase Admin SDK's verify-id-token failure, so it is
 * matched as a substring of the response body's `error`; UNAVAILABLE_TOKEN is the whole
 * `error` when a request carried no token at all. `src/client.ts` reads both.
 */
export const INVALID_TOKEN =
  "see https://firebase.google.com/docs/auth/admin/verify-id-tokens for details on how to retrieve a valid ID token";

export const UNAVAILABLE_TOKEN = "Token not available";
